// 目前所有營運的市場
// CAUTION: 建立訂單會用 dittoCountryCode 根據這個清單，判斷是否可以下單
export const REGION = {
  TW: 'TW',
  HK: 'HK',
  KR: 'KR',
  JP: 'JP',
}

// 由國家名稱取得國碼
export const REGION_CODE_MAP: Record<string, (typeof REGION)[keyof typeof REGION]> = {
  Taiwan: REGION.TW,
  'Hong Kong': REGION.HK,
  'South Korea': REGION.KR,
  Japan: REGION.JP,
}

// 由國碼取得國家名稱
export const REGION_NAME_MAP: Record<(typeof REGION)[keyof typeof REGION], keyof typeof REGION_CODE_MAP> = {
  [REGION.TW]: 'Taiwan',
  [REGION.HK]: 'Hong Kong',
  [REGION.KR]: 'South Korea',
  [REGION.JP]: 'Japan',
}
